<template>
    <div class="container-fluid-grid">
        <div class="form-row">
            <div class="form-group col-md-1 col-6">
                <label for="customerEditIsForeign" class="required">Extrangeiro?</label>
                <div class="form-check form-check-inline">
                    <input class="form-check-inline checkbox m green"
                           v-model="entity.is_foreign"
                           type="checkbox"
                           id="customerEditIsForeign">
                </div>
            </div>
            <div class="form-group col-md-2 col-6">
                <label for="customerEditCommercialDoc" class="required">{{entity.is_foreign ? 'ID' : (isCompany ? 'CNPJ' : 'CPF')}}</label>
                <input v-if="!entity.is_foreign"
                       :key="entity.is_foreign"
                       id="customerEditCommercialDoc"
                       class="form-control form-control-sm"
                       :class="{'is-invalid': errors.document}"
                       type="text"
                       maxlength="18"
                       v-mask="['##.###.###/####-##', '###.###.###/##']"
                       v-model="entity.document">
                <input v-else :key="entity.is_foreign"
                       id="customerEditCommercialDoc"
                       class="form-control form-control-sm"
                       :class="{'is-invalid': errors.document}"
                       type="text"
                       maxlength="15"
                       v-model="entity.document">
                <field-messages :errors="errors.document"/>
            </div>
            <div class="form-group col-md-2">
                <label for="customerEditName" class="required">{{entity.is_foreign ? 'Nome' : (isCompany ? 'Razão Social' : 'Nome')}}</label>
                <input id="customerEditName"
                       maxlength="100"
                       required
                       class="form-control form-control-sm"
                       :class="{'is-invalid': errors.name}"
                       type="text"
                       v-model="entity.name">
                <field-messages :errors="errors.name"/>
            </div>
            <div class="form-group col-md-2">
                <label for="customerEditCommercialName" class="required">{{entity.is_foreign ? 'Apelido' : (isCompany ? 'Nome Fantasia' : 'Apelido')}}</label>
                <input id="customerEditCommercialName"
                       maxlength="100"
                       required
                       class="form-control form-control-sm"
                       :class="{'is-invalid': errors.commercial_name}"
                       type="text"
                       v-model="entity.commercial_name">
                <field-messages :errors="errors.commercial_name"/>
            </div>
            <div class="form-group col-md-2 col-6">
                <label for="customerEditCommercialIE">Inscrição Estadual</label>
                <input id="customerEditCommercialIE"
                       maxlength="15"
                       :required="isCompany"
                       class="form-control form-control-sm"
                       :class="{'is-invalid': errors.inscricao_estadual}"
                       type="text"
                       v-model="entity.inscricao_estadual">
                <field-messages :errors="errors.inscricao_estadual"/>
            </div>
            <div class="form-group col-md-2 col-12">
                <label for="customerEditCommercialIM">Inscrição Municipal</label>
                <input id="customerEditCommercialIM"
                       maxlength="15"
                       :required="isCompany"
                       :disabled="!isCompany"
                       class="form-control form-control-sm"
                       :class="{'is-invalid': errors.inscricao_municipal}"
                       type="text"
                       v-model="entity.inscricao_municipal">
                <field-messages :errors="errors.inscricao_municipal"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-3">
                <label for="customerEditGroup" class="required">Grupo</label>
                <div style="display: grid; grid-template-columns: 1fr 2em">
                    <Autocomplete id="customerEditGroup"
                                  v-model="entity.group_name"
                                  placeholder="Informe o grupo"
                                  url="/v1/customers/search_groups?name="
                                  :input-class="['form-control form-control-sm not-b-r-top-right not-b-r-bottom-right', {'is-invalid': errors.customer_group_id}]"
                                  :on-select-item="returnValue"
                                  :item-presentation="itemPresentation"
                                  :item-value-presentation="itemValuePresentation"/>
                    <button type="button"
                            @click="showCustomerGroups"
                            class="btn btn-sm btn-theme-1 not-b-r-top-left not-b-r-bottom-left"><svg-icon icon="pencil-alt"/></button>
                </div>

                <field-messages :errors="errors.customer_group_id"/>
            </div>
            <div class="col-md-1 col-3 form-group">
                <label>Ativo</label>
                <div class="checkbox-inline" style="padding: 5px">
                    <label class="c-theme f-w-700">
                        <input type="checkbox"
                               v-model="entity.is_active"
                               @change="entity.disable_reason = null"
                               class="checkbox green m"/>&nbsp;{{entity.is_active | bool2Human}}</label>
                </div>
            </div>
            <div class="form-group col-md-4 col-9">
                <label for="customerEditReason" :class="{required: !entity.is_active}">Motivo</label>
                <input id="customerEditReason"
                       maxlength="100"
                       :disabled="entity.is_active"
                       :required="!entity.is_active"
                       class="form-control form-control-sm"
                       :class="{'is-invalid': errors.disable_reason}"
                       type="text"
                       v-model="entity.disable_reason">
                <field-messages :errors="errors.disable_reason"/>
            </div>
            <div class="form-group col-md-4">
                <label for="customerEditUrlSite">Site</label>
                <input id="customerEditUrlSite"
                       maxlength="2083"
                       placeholder="Ex.: http://www.sitedocliente.com.br"
                       class="form-control form-control-sm"
                       :class="{'is-invalid': errors.url_site}"
                       type="url"
                       v-model="entity.url_site">
                <field-messages :errors="errors.url_site"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-1 col-3">
                <label for="customerEditPostalCode" class="required">{{entity.is_foreign ? 'Zip Code' : 'CEP'}}</label>
                <input id="customerEditPostalCode"
                       :key="entity.is_foreign"
                       maxlength="9"
                       class="form-control form-control-sm"
                       :class="{'is-invalid': errors.postal_code}"
                       type="text"
                       @keyup="searchPostalCode($event)"
                       v-mask="entity.is_foreign ? '########' : '#####-###'"
                       v-model="entity.postal_code">
                <field-messages :errors="errors.postal_code"/>
            </div>
            <div class="form-group col-md-3 col-9">
                <label for="customerEditCity" class="required">Cidade</label>
                <Autocomplete id="customerEditCity"
                              v-model="entity.city_name"
                              url="/v1/location/search_cities?city_name="
                              :input-class="['form-control form-control-sm not-b-r-top-right not-b-r-bottom-right', {'is-invalid': errors.city_id}]"
                              :on-select-item="returnCity"
                              :item-presentation="cityPresentation"
                              :item-value-presentation="cityValuePresentation"/>

                <field-messages :errors="errors.city_id"/>
            </div>
            <div class="form-group col-md-3 col-6">
                <label for="customerEditNeighborhood" class="required">Bairro</label>
                <input id="customerEditNeighborhood"
                       maxlength="100"
                       required
                       class="form-control form-control-sm"
                       :class="{'is-invalid': errors.neighborhood}"
                       type="text"
                       v-model="entity.neighborhood">
                <field-messages :errors="errors.neighborhood"/>
            </div>
            <div class="form-group col-md-3 col-6">
                <label for="customerEditAddress" class="required">Endereço</label>
                <input id="customerEditAddress"
                       maxlength="100"
                       required
                       class="form-control form-control-sm"
                       :class="{'is-invalid': errors.address}"
                       type="text"
                       v-model="entity.address">
                <field-messages :errors="errors.address"/>
            </div>
            <div class="form-group col-md-1 col-6">
                <label for="customerEditAddressNumber">Número</label>
                <input id="customerEditAddressNumber"
                       maxlength="20"
                       class="form-control form-control-sm"
                       :class="{'is-invalid': errors.address_number}"
                       type="text"
                       v-model="entity.address_number">
                <field-messages :errors="errors.address_number"/>
            </div>
            <div class="form-group col-md-1 col-6">
                <label for="customerEditAddressNotes">Complemento</label>
                <input id="customerEditAddressNotes"
                       maxlength="40"
                       class="form-control form-control-sm"
                       :class="{'is-invalid': errors.address_notes}"
                       type="text"
                       v-model="entity.address_notes">
                <field-messages :errors="errors.address_notes"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-12">
                <label for="customerEditNotes">Observações</label>
                <textarea v-model="entity.notes" id="customerEditNotes" class="form-control form-control-sm"></textarea>
                <field-messages :errors="errors.notes"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Autocomplete from '@/components/particles/Autocomplete'
    import {EventBus} from "../../utils/EventBus";

    export default {
        name: "GeneralTab",
        components: {
            Autocomplete
        },
        props: {
            errors: {
                type: Object,
                default: {}
            },
            entity: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                cachePostalCode: {},
                //isCompany: true
            }
        },
        methods: {
            returnValue(obj) {
                this.entity.customer_group_id = obj.id
            },
            itemValuePresentation: obj => obj.name,
            itemPresentation(obj, val) {
                const regex = new RegExp(val, 'gi');
                const name = this.$appUtils.highlightText(obj.name, regex);

                return ['<div class="ellipsis">', name, '</div>'].join('');
            },
            returnCity(obj) {
                this.entity.city_id = obj.id
            },
            cityValuePresentation: obj =>  {
                if(obj.state.acronym) {
                    return `${obj.name}/${obj.state.acronym}`
                }


                return `${obj.name}/${obj.state.name}/${obj.state.country.acronym}`
            },
            cityPresentation(obj, val) {
                const regex = new RegExp(val, 'gi');
                const {state} = obj;
                const name = this.$appUtils.highlightText(obj.name, regex);
                const label = ['<div class="ellipsis">', name, '</div>', '<div>Estado: ', state.name, '/']

                if (state.acronym) label.push(state.acronym);
                else {
                    label.push(state.name, '/', state.country.acronym);
                }


                label.push('<div>');

                return label.join('');
            },
            setAddress(data) {
                this.entity.city_name = `${data.neighborhood.city.name}/${data.neighborhood.city.state.acronym}`;
                this.entity.city_id = data.neighborhood.city.id;
                this.entity.neighborhood = data.neighborhood.name;
                this.entity.address = data.address;
            },
            searchPostalCode(e) {
                if (this.entity.is_foreign) return;

                const postal_code = (e.target.value || '').replace(/\D+/, '');

                if (postal_code.length === 8) {
                    if (this.cachePostalCode[postal_code]) this.setAddress(this.cachePostalCode[postal_code]);
                    else {
                        this.$appHttp.get(`/v1/location/search_postal_code/${postal_code}`)
                            .then(({data}) => {
                                this.$set(this.cachePostalCode, postal_code, data);
                                this.setAddress(data)
                            })
                            .catch(({response}) => {
                                this.$appUtils.vibrate();
                                if (response.status === 404) this.$snotify.warning('CEP não encontrado', this.$appStorage.getUser().name);
                            })
                    }
                }
            },
            showCustomerGroups() {
                EventBus.showCustomerGroup(() => {}, {});
            }
        }
        ,computed: {
            isCompany() {
                return (this.entity.document || '').replace(/\D/g, '').length > 11
            }
        }
    }
</script>
